// extracted by mini-css-extract-plugin
export var dataCell = "_n7-2";
export var dataRow = "_n7-0";
export var headerRow = "_n7-1";